import { render, staticRenderFns } from "./ProgrammesComponent.vue?vue&type=template&id=1e06a8af&scoped=true"
import script from "./ProgrammesComponent.vue?vue&type=script&lang=js"
export * from "./ProgrammesComponent.vue?vue&type=script&lang=js"
import style0 from "./ProgrammesComponent.vue?vue&type=style&index=0&id=1e06a8af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06a8af",
  null
  
)

export default component.exports